module.exports = __webpack_public_path__ + "static/media/TUR.56bdcfa9.svg";